import { EmptyView } from '@components'

import { Color, Icon } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

export const ReviewEntriesEmptyQueueState = (): ReactElement => (
  <Styled.ReviewEntriesEmptyQueueStateWrapper>
    <EmptyView
      illustration={
        <Styled.SuccessSquircle>
          <Icon aria-hidden="true" color={Color.Green700} icon="check" />
        </Styled.SuccessSquircle>
      }
      tDescription="review_entries.empty.description"
      tTitle="review_entries.empty.title"
    />
  </Styled.ReviewEntriesEmptyQueueStateWrapper>
)
